/**
 * The Cognito pool's OIDC authority, in ONE place.
 *
 * Everything about ending or starting a session must agree on which pool and, through
 * its discovery document, which hosted-UI host is authoritative. docs/29 F15 is what
 * happens when two halves of that answer are maintained separately: sign-in followed the
 * discovery document, sign-out followed a build-time domain, a custom hosted-UI domain
 * moved one and not the other, and sign-out silently stopped working.
 *
 * Deliberately free of any `window` access, unlike `config.ts` (which builds redirect
 * URIs from `window.location.origin`). That lets non-DOM modules import the authority
 * without dragging a browser dependency into suites that run under the node environment.
 */

export function cognitoAuthority(): string {
  return `https://cognito-idp.${import.meta.env.VITE_APP_REGION}.amazonaws.com/${import.meta.env.VITE_COGNITO_USER_POOL_ID}`;
}

/** The pool's OIDC discovery document: the authoritative source for `authorization_endpoint`,
 *  `end_session_endpoint` and `revocation_endpoint`. Null when the pool is not configured. */
export function discoveryDocumentUrl(): string | null {
  const authority = cognitoAuthority().replace(/\/+$/, '');
  if (!import.meta.env.VITE_APP_REGION || !import.meta.env.VITE_COGNITO_USER_POOL_ID) return null;
  return `${authority}/.well-known/openid-configuration`;
}
